import Image from 'next/image';
import Link from 'next/link';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import fb from '/public/home/header/fb.svg';
import youtube from '/public/home/header/youtube.svg';
import call from '/public/home/header/call.svg';
import location from '/public/home/header/location.svg';

import w_fb from '/public/home/header/w_fb.svg';
import w_youtube from '/public/home/header/w_youtube.svg';
import w_call from '/public/home/header/w_call.svg';
import w_location from '/public/home/header/w_location.svg';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 6,
    },
    menuText: {},
});

const Contact = ({ ...props }) => {
    const classes = useStyles({ windowsize: props.windowsize });

    const coloredSvg = [
        {
            name: fb,
            style: { marginRight: props.windowsize > 1000 ? '15px' : '5px', cursor: 'pointer' },
            isLink: true,
            link: 'https://www.facebook.com/instituteofmedicalsciences1',
        },
        {
            name: youtube,
            style: { marginRight: props.windowsize > 1000 ? '15px' : '5px', cursor: 'pointer' },
            isLink: true,
            link: 'https://www.youtube.com/@%D0%90%D0%BD%D0%B0%D0%B3%D0%B0%D0%B0%D1%85%D1%83%D1%85%D0%B0%D0%B0%D0%BD%D1%8B%D1%85%D2%AF%D1%80%D1%8D%D1%8D%D0%BB%D1%8D%D0%BD',
        },
        {
            name: location,
            style: { marginRight: props.windowsize > 1000 ? '15px' : '5px', cursor: 'pointer' },
            isLink: true,
            link: `http://google.com/maps/place/47%C2%B054'52.7%22N+106%C2%B051'24.1%22E/@47.9138854,106.8561099,362m/data=!3m1!1e3!4m12!1m7!3m6!1s0x5d969319714c80db:0x57249bffe39e9812!2z0KPQu9Cw0LzQttC70LDQu9GCINCQ0L3QsNCz0LDQsNGFINCj0YXQsNCw0L0g0KLQtdGF0L3QvtC70L7Qs9C40LnQvSDQpdKv0YDRjdGN0LvRjdC9!8m2!3d47.8935145!4d106.8982927!16s%2Fg%2F11jbnfv3zf!3m3!8m2!3d47.914625!4d106.856702!5m1!1e1?entry=ttu&g_ep=EgoyMDI1MDMwMi4wIKXMDSoASAFQAw%3D%3D`,
        },
        { name: call },
    ];

    const whiteSvg = [
        { name: w_fb, link: 'https://www.facebook.com/instituteofmedicalsciences1' },
        {
            name: w_youtube,
            link: 'https://www.youtube.com/@%D0%90%D0%BD%D0%B0%D0%B3%D0%B0%D0%B0%D1%85%D1%83%D1%85%D0%B0%D0%B0%D0%BD%D1%8B%D1%85%D2%AF%D1%80%D1%8D%D1%8D%D0%BB%D1%8D%D0%BD',
        },
        {
            name: w_location,
            link: `http://google.com/maps/place/47%C2%B054'52.7%22N+106%C2%B051'24.1%22E/@47.9138854,106.8561099,362m/data=!3m1!1e3!4m12!1m7!3m6!1s0x5d969319714c80db:0x57249bffe39e9812!2z0KPQu9Cw0LzQttC70LDQu9GCINCQ0L3QsNCz0LDQsNGFINCj0YXQsNCw0L0g0KLQtdGF0L3QvtC70L7Qs9C40LnQvSDQpdKv0YDRjdGN0LvRjdC9!8m2!3d47.8935145!4d106.8982927!16s%2Fg%2F11jbnfv3zf!3m3!8m2!3d47.914625!4d106.856702!5m1!1e1?entry=ttu&g_ep=EgoyMDI1MDMwMi4wIKXMDSoASAFQAw%3D%3D`,
        },
        {
            name: w_call,
            link: `http://google.com/maps/place/47%C2%B054'52.7%22N+106%C2%B051'24.1%22E/@47.9138854,106.8561099,362m/data=!3m1!1e3!4m12!1m7!3m6!1s0x5d969319714c80db:0x57249bffe39e9812!2z0KPQu9Cw0LzQttC70LDQu9GCINCQ0L3QsNCz0LDQsNGFINCj0YXQsNCw0L0g0KLQtdGF0L3QvtC70L7Qs9C40LnQvSDQpdKv0YDRjdGN0LvRjdC9!8m2!3d47.8935145!4d106.8982927!16s%2Fg%2F11jbnfv3zf!3m3!8m2!3d47.914625!4d106.856702!5m1!1e1?entry=ttu&g_ep=EgoyMDI1MDMwMi4wIKXMDSoASAFQAw%3D%3D`,
        },
    ];

    return (
        <Box
            style={{
                display: 'flex',
                justifyContent: props.windowsize > 700 ? 'unset' : 'end',
                alignItems: 'center',
                marginTop: 15,
            }}
            {...props}
        >
            {props.type === 'header' ? (
                <>
                    {coloredSvg.map((item, ind) => {
                        return (
                            <div key={ind} style={item.style}>
                                {item.isLink ? (
                                    <Link legacyBehavior target="_blank" href={item.link} passHref>
                                        <a target="_blank" rel="noreferrer">
                                            <Image
                                                src={item.name}
                                                width={props.windowsize > 700 ? 42 : 22}
                                                height={props.windowsize > 700 ? 42 : 22}
                                                alt="logo image"
                                                priority
                                                fetchpriority="high"
                                            />
                                        </a>
                                    </Link>
                                ) : (
                                    <Image
                                        src={item.name}
                                        width={props.windowsize > 700 ? (ind === 0 ? 46 : 42) : 22}
                                        height={props.windowsize > 700 ? (ind === 0 ? 46 : 42) : 22}
                                        alt="logo image"
                                        priority
                                        fetchpriority="high"
                                    />
                                )}
                            </div>
                        );
                    })}
                    {props.windowsize > 1000 ? (
                        <Typography
                            variant="h6"
                            style={{
                                color: '#2E3192',
                                fontWeight: 700,
                                fontSize: props.windowsize > 700 ? '18px' : '14px',
                                marginLeft: 10,
                                whiteSpace: 'nowrap',
                            }}
                        >
                            +(976) 70287890
                        </Typography>
                    ) : (
                        ''
                    )}
                </>
            ) : (
                <>
                    {whiteSvg.map((item, ind) => {
                        return (
                            <div
                                key={ind}
                                style={{ marginRight: props.windowsize > 700 ? '30px' : '10px' }}
                            >
                                <Link legacyBehavior target="_blank" href={item.link} passHref>
                                    <a target="_blank" rel="noreferrer">
                                        <Image
                                            src={item.name}
                                            width={props.windowsize > 700 ? 42 : 22}
                                            height={props.windowsize > 700 ? 42 : 22}
                                            alt="logo image"
                                            priority
                                            fetchpriority="high"
                                        />
                                    </a>
                                </Link>
                            </div>
                        );
                    })}
                    <Typography
                        variant="h6"
                        style={{
                            color: 'white',
                            fontWeight: 700,
                            fontSize: props.windowsize > 700 ? '24px' : '14px',
                        }}
                    >
                        +(976) 70287890
                    </Typography>
                </>
            )}
        </Box>
    );
};

Contact.propTypes = {
    className: PropTypes.string,
};

export default Contact;
